import React from "react";
import Step1 from "./step/step-1";
import Step2 from "./step/step-2";
import Step3 from "./step/step-3";
import logo from "../assets/img/foto_apply.jpg";
import swal from "sweetalert";
import * as dateFns from "date-fns";
// import Countries from "../Countries.json";

class VersionOne extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getModalState();

    this.ErrorMessage = this.ErrorMessage.bind(this);
  }

  getModalState = () => {
    return {
      ApplicationObj: {
        Step1: {
          I20Number: "",
          DateOfBirth: null,
          Name: "",
          CurrentLevel: "",
          CurrentCampus: "",
          CurrentSemester: "",
          SemesterStartDate: null,
          CurrentStatus: "",
          PlanId: -1,
          CampusId: -1,
          PeriodId: -1,
          SubjectId: "",
          CurrentOrder: -1,
          ErrorMsgValidate: "",
          Courses: [],
          StudentClasses: [],
          Subjects: [],
          ValidatingStudent: false,
          OtherReason: "",
          LevelReason: "",
          Failed: false,
          InvalidEmail: false,
          Email: "",
          PhoneNumber: "",
          PhoneNumberIsValid: true,
          Street: "",
          Street2: "",
          City: "",
          State: "",
          Zip: "",
          Country: "United States",
          ContactInfoConfirmed: false,
          ContactInfoEditable: false,
          trimmedDataURL: null,
          trimmedDataURLInitials: null,
          SubmittingApplication: false,
          ErrorSubmit: "",
          IsNonF1: false,
          SelfEnrollStartDate: null,
          SelfEnrollEndDate: null,
          SelfEnrollDiscountDate: null,
          SelfEnrollDiscountPaymentDate: null,
          ApplyDiscountRule: false
        },
        Step2: {
          FinanceId: -1,
          trimmedDataURL: null,
          trimmedDataURLInitials: null,
          Agree1: false,
          Agree2: false,
          SubmittingApplication: false,
          ErrorSubmit: ""
        },
        Step3: {
          Active: false,
          Satisfied: null,
          PreferredLevel: null,
          PreferredPeriod: null,
          Submitting: false,
          Submitted: false,
          ErrorSubmit: ""
        }
      }
    };
  };

  render() {
    let subject = this.getSubject();

    return (
      <div className="wrapper">
        <div className="steps-area steps-area-fixed">
          <div className="image-holder">
            <img src={logo} alt="" />
          </div>
          <div className="steps clearfix">
            <ul className="tablist multisteps-form__progress">
              <li className="multisteps-form__progress-btn js-active current">
                <span>1</span>
              </li>
              <li className="multisteps-form__progress-btn">
                <span>2</span>
              </li>
              <li className="multisteps-form__progress-btn last">
                <span>3</span>
              </li>
            </ul>
          </div>
        </div>
        <form
          className="multisteps-form__form"
          action="#"
          id="wizard"
          method="POST"
        >
          <div className="form-area position-relative">
            <Step1
              data={this.state.ApplicationObj.Step1}
              planRender={this.planRender.bind(this)}
              campusRender={this.campusRender.bind(this)}
              periodRender={this.periodRender.bind(this)}
              applicationObj={this.state.ApplicationObj}
              validateStudent={this.validateStudent}
              handleUserInput={this.handleUserInput.bind(this)}
              handleSubmitBreak={this.handleSubmitBreak.bind(this)}
              emailOnBlur={this.emailOnBlur.bind(this)}
              clear={this.clear}
              clearInitials={this.clearInitials}
              trim={this.trim}
              trimInitials={this.trimInitials}
              handleSelectStateChange={this.handleSelectStateChange.bind(this)}
              handlePhoneNumberChange={this.handlePhoneNumberChange.bind(this)}
              subjectRender={this.subjectRender.bind(this)}
              Subject={subject}
              campusChange={this.isCampusChange()}
              applyDiscountRule={
                this.state.ApplicationObj.Step1.ApplyDiscountRule
              }
              handleContactInfoToggle={this.handleContactInfoToggle.bind(this)}
              // Countries={Countries}
            />
            {!this.state.ApplicationObj.Step3.Active && (
              <Step2
                data={this.state.ApplicationObj.Step2}
                step2FinanceRender={this.step2FinanceRender.bind(this)}
                clear={this.clear}
                clearInitials={this.clearInitials}
                trim={this.trim}
                trimInitials={this.trimInitials}
                handleCheckbox={this.handleCheckbox.bind(this)}
                handleSubmit={this.handleSubmit.bind(this)}
                // LevelId={this.state.ApplicationObj.Step1.LevelId}
                IsNonF1={this.state.ApplicationObj.Step1.IsNonF1}
                Courses={this.state.ApplicationObj.Step1.Courses}
                Subject={subject}
                selfEnrollDiscountDate={
                  this.state.ApplicationObj.Step1.SelfEnrollDiscountDate
                }
                applyDiscountRule={
                  this.state.ApplicationObj.Step1.ApplyDiscountRule
                }
              />
            )}
            {this.state.ApplicationObj.Step3.Active && (
              <Step3
                data={this.state.ApplicationObj.Step3}
                currentOrder={this.state.ApplicationObj.Step1.CurrentOrder}
                onSatisfiedChange={this.handleStep3SatisfiedChange.bind(this)}
                onPreferredLevelChange={this.handleStep3LevelChange.bind(this)}
                onPreferredPeriodChange={this.handleStep3PeriodChange.bind(
                  this
                )}
                onSubmit={this.handleStep3Submit.bind(this)}
              />
            )}
          </div>
        </form>
      </div>
    );
  }

  getSubject = () => {
    let subject = this.state.ApplicationObj.Step1.Subjects.find(
      (x) => x.id == this.state.ApplicationObj.Step1.SubjectId
    );

    return subject;
  };

  planRender = (id) => {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        let Step1 = ApplicationObj.Step1;

        Step1.PlanId = id;

        return { ApplicationObj };
      }, resolve(true));
    });
  };

  campusRender = (id) => {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        let Step1 = ApplicationObj.Step1;

        Step1.CampusId = id;
        Step1.SubjectId = "";

        return { ApplicationObj };
      }, resolve(true));
    });
  };

  periodRender = (id) => {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        let Step1 = ApplicationObj.Step1;

        Step1.PeriodId = id;

        return { ApplicationObj };
      }, resolve(true));
    });
  };

  subjectRender = (id) => {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        let Step1 = ApplicationObj.Step1;

        Step1.SubjectId = id;

        return { ApplicationObj };
      }, resolve(true));
    });
  };

  // levelRender = (id) => {
  //   return new Promise((resolve, reject) => {
  //     this.setState((prevState) => {
  //       let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
  //       let Step1 = ApplicationObj.Step1;

  //       Step1.LevelId = id;

  //       return { ApplicationObj };
  //     }, resolve(true));
  //   });
  // };

  step2PeriodRender = (id) => {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        let Step2 = ApplicationObj.Step2;

        Step2.PeriodId = id;

        return { ApplicationObj };
      }, resolve(true));
    });
  };

  handleUserInput = (step, e) => {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        let obj = ApplicationObj[step];

        obj[e.target.name] = e.target.value;

        return { ApplicationObj };
      }, resolve(true));
    });
  };

  clear = (parent) => {
    return new Promise((resolve, reject) => {
      this.setState(
        (prevState) => {
          let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
          let obj = ApplicationObj[parent];

          obj.trimmedDataURL = null;

          return { ApplicationObj };
        },

        resolve(true)
      );
    });
  };

  clearInitials = (parent) => {
    return new Promise((resolve, reject) => {
      this.setState(
        (prevState) => {
          let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
          let obj = ApplicationObj[parent];

          obj.trimmedDataURLInitials = null;

          return { ApplicationObj };
        },

        resolve(true)
      );
    });
  };

  trim = (canvas, parent) => {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        let obj = ApplicationObj[parent];

        obj.trimmedDataURL = canvas;

        return { ApplicationObj };
      }, resolve(true));
    });
  };

  trimInitials = (canvas, parent) => {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        let obj = ApplicationObj[parent];

        obj.trimmedDataURLInitials = canvas;

        return { ApplicationObj };
      }, resolve(true));
    });
  };

  getPlanInitial() {
    let id = this.state.ApplicationObj.Step1.PlanId;

    return id === 1
      ? "S"
      : id === 2
        ? "B"
        : id === 3
          ? "C"
          : id === 4
            ? "O"
            : "";
  }

  getCampusName() {
    let id = this.state.ApplicationObj.Step1.CampusId;

    return id === 1
      ? "Online Combined Campuses"
      : id === 2
        ? "Orem In Person"
        : id === 3
          ? "Salt Lake in Person"
          : id === 4
            ? "Seattle in Person"
            : "";
  }

  isCampusChange() {
    const step1 = this.state.ApplicationObj.Step1;
    const chosen = this.getCampusName();
    const current = step1.CurrentCampus || "";

    return (
      step1.PlanId === 1 &&
      chosen.length > 0 &&
      current.length > 0 &&
      chosen.toLowerCase() !== current.toLowerCase()
    );
  }

  isValidating(bool) {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        let obj = ApplicationObj.Step1;

        obj.ValidatingStudent = bool;

        return { ApplicationObj };
      }, resolve(true));
    });
  }

  isSubmitting(bool, parent) {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        let obj = ApplicationObj[parent];

        obj.SubmittingApplication = bool;

        return { ApplicationObj };
      }, resolve(true));
    });
  }

  getDaysFromNumber(period) {
    if (period == "M" || period == "E") return "Mon/Tue/Wed/Thu";
    else if (period == "MM" || period == "EM") return "Mon/Tue";
    else if (period == "MW" || period == "EW") return "Wed/Thu";
    else if (period == "MT") return "Mon/Tue";
    else if (period == "WT") return "Wed/Thue";
    else if (period == "TW") return "Tue/Wed";
    else if (period == "HW") return "Wed";
    else if (period == "S") return "Sat";
    else if (period == "MO") return "Mon";
    else if (period == "TU") return "Tue";
    else return "";
  }

  validateStudent = () => {
    if (
      this.state.ApplicationObj.Step1.I20Number.length > 0 &&
      this.state.ApplicationObj.Step1.DateOfBirth.length > 0
    ) {
      this.isValidating(true).then(() => {
        const self = this;

        const requestOptions = {
          crossDomain: true,
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        };

        const isDevelopment = false;
        const url = isDevelopment
          ? "http://localhost:58794"
          : "https://api.lumos.edu";

        return fetch(
          url +
            "/selfenroll/validatestudent?i20=" +
            encodeURIComponent(self.state.ApplicationObj.Step1.I20Number) +
            "&dateofbirth=" +
            encodeURIComponent(self.state.ApplicationObj.Step1.DateOfBirth),
          requestOptions
        )
          .then((response) => response.json())
          .then((data) => {
            return new Promise((resolve, reject) => {
              self.setState((prevState) => {
                let ApplicationObj = Object.assign(
                  {},
                  prevState.ApplicationObj
                );
                let obj = ApplicationObj.Step1;

                if (data.success === true) {
                  obj.Name = data.data.name;
                  obj.CurrentLevel = data.data.courseName;
                  obj.CurrentOrder = data.data.courseOrder;
                  obj.CurrentSemester = data.data.semesterName;
                  obj.SemesterStartDate = dateFns.parseISO(
                    data.data.semesterStartDate
                  );
                  obj.CurrentCampus = data.data.campusName;
                  obj.CurrentStatus = data.data.statusList[0].statusType.name;
                  obj.Failed = data.data.failed;
                  obj.IsNonF1 = data.data.visaType.name !== "Student F1";

                  // Pre-fill contact information from the API response
                  obj.Email = data.data.address.email || "";
                  const phoneNumberInfo = self.normalizePhoneNumber(
                    data.data.address.cellPhone
                  );
                  obj.PhoneNumber = phoneNumberInfo.formatted;
                  obj.PhoneNumberIsValid = phoneNumberInfo.isValid;
                  obj.Street = data.data.address.street || "";
                  obj.Street2 = data.data.address.street2 || "";
                  obj.City = data.data.address.city || "";
                  obj.State = data.data.address.state || "";
                  obj.Zip = data.data.address.zip || "";

                  // Reset confirmation flags whenever student is re-validated
                  obj.ContactInfoConfirmed = false;
                  obj.ContactInfoEditable = false;

                  obj.Courses = [];
                  data.data.courseList.map((course, index) => {
                    obj.Courses.push({
                      id: course.id,
                      order: course.order,
                      name: course.name,
                      tuitionCost: course.tuitionCost,
                      newTuitionCost: course.newTuitionCost
                    });
                  });

                  obj.StudentClasses = [];
                  data.data.studentClasses.map((sc, index) => {
                    obj.StudentClasses.push({
                      code: sc.classe.code,
                      grade: ((sc.marks / sc.classe.marks) * 100).toFixed(2)
                    });
                  });

                  obj.Subjects = [];
                  data.data.subjectList
                    .sort((a, b) => {
                      if (a.course.order !== b.course.order) {
                        return a.course.order - b.course.order;
                      }

                      const periodOrder = {
                        M: 1,
                        E: 2,
                        MM: 2.1,
                        MW: 2.2,
                        EM: 2.3,
                        EW: 2.4,
                        MT: 3,
                        WT: 4,
                        HW: 5,
                        S: 6,
                        MO: 7,
                        TU: 8,
                        TW: 9
                      };
                      return periodOrder[a.period] - periodOrder[b.period];
                    })
                    .map((s, index) => {
                      obj.Subjects.push({
                        id: s.id,
                        courseOrder: s.course.order,
                        period: s.period,
                        campusName: s.campus.name,
                        campusFixedTuitionCost: s.campus.fixedTuitionCost,
                        periodName:
                          s.period == "MT"
                            ? "Super Intensive"
                            : s.period == "WT"
                              ? "Super Intensive"
                              : s.period == "TW"
                                ? "Super Intensive"
                              : s.period == "M"
                                ? "Morning"
                                : s.period == "E"
                                  ? "Evening"
                                  : s.period == "MM" || s.period == "MW"
                                    ? "Morning Lab"
                                    : s.period == "EM" || s.period == "EW"
                                      ? "Evening Lab"
                                  : s.period == "HW"
                                    ? "Lab Hybrid"
                                    : s.period == "S"
                                      ? "Intensive + Lab"
                                      : s.period == "MO"
                                        ? "Intensive + Lab"
                                        : s.period == "TU"
                                          ? "Intensive + Lab"
                                          : "",
                        levelName:
                          s.course.order == 7
                            ? "TOEFL "
                            : s.course.order == 12
                              ? "Level 7"
                              : s.course.order == 13
                                ? "Level 8"
                              : "Level " + s.course.order + " ",

                        line2: this.getDaysFromNumber(s.period),
                        line3:
                          s.period == "TW" && s.campus.name == "Seattle in Person"
                            ? "1:00 pm to 10:00 pm"
                            : (s.period == "MM" || s.period == "MW") &&
                              s.campus.name == "Salt Lake in Person"
                              ? "8:00 am to 12:30 pm"
                              : s.period == "MT"
                            ? "8:00 am to 5:00 pm"
                            : s.period == "WT"
                              ? "8:00 am to 5:00 pm"
                              : s.period == "TW"
                                ? "8:00 am to 5:00 pm"
                              : s.period == "M"
                                ? "9:00 am to 1:30 pm"
                                : s.period == "E"
                                  ? "5:00 pm to 9:30 pm"
                                  : s.period == "MM" || s.period == "MW"
                                    ? "9:00 am to 1:30 pm"
                                    : s.period == "EM" || s.period == "EW"
                                      ? "5:00 pm to 9:30 pm"
                                  : s.period == "HW"
                                    ? "8:00 am to 5:00 pm"
                                    : s.period == "S"
                                      ? "8:00 am to 5:00 pm"
                                      : s.period == "MO"
                                        ? "8:00 am to 5:00 pm"
                                        : s.period == "TU"
                                          ? "8:00 am to 5:00 pm"
                                          : "",
                        periodColor:
                          s.period == "MT" ||
                          s.period == "MO" ||
                          s.period == "TU" ||
                          s.period == "TW" ||
                          s.period == "S"
                            ? "red"
                            : s.period == "WT"
                              ? "red"
                              : s.period == "M" ||
                                s.period == "MM" ||
                                s.period == "MW"
                                ? "#f58220"
                                : s.period == "E" ||
                                  s.period == "EM" ||
                                  s.period == "EW"
                                  ? "#212529"
                                  : s.period == "HW"
                                    ? "red"
                                    : ""
                      });
                    });

                  // obj.I20Number = "";
                  //obj.DateOfBirth = "";

                  obj.SelfEnrollStartDate = dateFns.parseISO(
                    data.data.selfEnrollStartDate
                  );

                  obj.SelfEnrollEndDate = dateFns.parseISO(
                    data.data.selfEnrollEndDate
                  );

                  obj.SelfEnrollDiscountPaymentDate = dateFns.parseISO(
                    data.data.selfEnrollDiscountPaymentDate
                  );

                  obj.SelfEnrollDiscountDate = dateFns.parseISO(
                    data.data.selfEnrollDiscountDate
                  );

                  let applyDiscountRule =
                    dateFns.isSameDay(
                      new Date(),
                      dateFns.parseISO(data.data.selfEnrollDiscountDate)
                    ) ||
                    dateFns.isBefore(
                      new Date(),
                      dateFns.parseISO(data.data.selfEnrollDiscountDate)
                    )
                      ? true
                      : false;

                  obj.ApplyDiscountRule = applyDiscountRule;

                  obj.ErrorMsgValidate = "";
                } else {
                  let message = "";
                  if (data.messages)
                    message = data.messages.map((error) => error).join("\n");

                  obj.Name = "";
                  obj.CurrentLevel = "";
                  obj.CurrentSemester = "";
                  obj.SemesterStartDate = null;
                  obj.CurrentCampus = "";
                  obj.CurrentStatus = "";
                  obj.Courses = [];
                  obj.StudentClasses = [];
                  obj.Subjects = [];
                  obj.IsNonF1 = false;

                  obj.SelfEnrollStartDate = null;
                  obj.SelfEnrollEndDate = null;
                  obj.SelfEnrollDiscountDate = null;
                  obj.SelfEnrollDiscountPaymentDate = null;

                  obj.ErrorMsgValidate = message;
                }

                obj.PlanId = -1;
                // obj.LevelId = -1;
                obj.CampusId = -1;
                obj.PeriodId = -1;
                obj.SubjectId = "";

                obj.ValidatingStudent = false;

                return { ApplicationObj };
              }, resolve(true));
            });
          })
          .catch(function (error) {
            return new Promise((resolve, reject) => {
              self.setState((prevState) => {
                let ApplicationObj = Object.assign(
                  {},
                  prevState.ApplicationObj
                );
                let obj = ApplicationObj.Step1;

                obj.ErrorMsgValidate = "Invalid information";

                obj.Name = "";
                obj.CurrentLevel = "";
                obj.CurrentSemester = "";
                obj.SemesterStartDate = null;
                obj.CurrentCampus = "";
                obj.CurrentStatus = "";
                obj.Courses = [];
                obj.StudentClasses = [];
                obj.IsNonF1 = false;

                obj.ValidatingStudent = false;

                return { ApplicationObj };
              }, resolve(true));
            });
          });
      });
    }
  };

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);

      reader.readAsDataURL(file);
    });
  }

  finishSubmit() {
    if (this.state.ApplicationObj.Step2.SubmittingApplication === false) {
      this.isSubmitting(true, "Step2").then(async () => {
        const self = this;

        let subject = this.state.ApplicationObj.Step1.Subjects.find(
          (x) => x.id == this.state.ApplicationObj.Step1.SubjectId
        );

        let applyObj = {
          I20: this.state.ApplicationObj.Step1.I20Number,
          Plan: this.getPlanInitial(),
          Period: subject.period,
          Level: subject.courseOrder,
          Campus: this.getCampusName(),
          FinancialPlan: this.state.ApplicationObj.Step2.FinanceId,
          Email: this.state.ApplicationObj.Step1.Email,
          PhoneNumber: this.state.ApplicationObj.Step1.PhoneNumber,
          Street: this.state.ApplicationObj.Step1.Street,
          Street2: this.state.ApplicationObj.Step1.Street2,
          City: this.state.ApplicationObj.Step1.City,
          State: this.state.ApplicationObj.Step1.State,
          Zip: this.state.ApplicationObj.Step1.Zip,
          OtherReason: this.state.ApplicationObj.Step1.OtherReason,
          LevelReason: this.state.ApplicationObj.Step1.LevelReason,
          DocumentSignature: {
            FileContentBase64: this.state.ApplicationObj.Step2.trimmedDataURL,
            FileName: "Signature.jpg"
          },
          DocumentInitials: {
            FileContentBase64:
              this.state.ApplicationObj.Step2.trimmedDataURLInitials,
            FileName: "Initials.jpg"
          }
        };

        const isDevelopment = false;
        const url = isDevelopment
          ? "http://localhost:58794"
          : "https://api.lumos.edu";

        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(applyObj)
        };

        return fetch(url + "/selfEnroll", requestOptions)
          .then((response) => response.json())
          .then((data) => {
            return new Promise((resolve, reject) => {
              self.setState((prevState) => {
                let ApplicationObj = Object.assign(
                  {},
                  prevState.ApplicationObj
                );
                let step2 = ApplicationObj.Step2;

                if (data.success === true) {
                  let Step3 = ApplicationObj.Step3;
                  Step3.Active = true;
                  step2.SubmittingApplication = false;
                  setTimeout(
                    () => window.scrollTo({ top: 0, behavior: "smooth" }),
                    100
                  );
                } else if (data.messages) {
                  let message = data.messages.map((error) => error).join("\n");

                  step2.ErrorSubmit = message;
                  step2.SubmittingApplication = false;
                } else {
                  step2.ErrorSubmit = "An internal server error has occurred.";
                  step2.SubmittingApplication = false;
                }

                return { ApplicationObj };
              }, resolve(true));
            });
          })
          .catch(function (error) {
            return new Promise((resolve, reject) => {
              self.setState((prevState) => {
                let ApplicationObj = Object.assign(
                  {},
                  prevState.ApplicationObj
                );
                let step2 = ApplicationObj.Step2;

                let msg = self.ErrorMessage(error);
                step2.ErrorSubmit =
                  "A server connection error occurred in your application. Error message: " +
                  msg;

                step2.SubmittingApplication = false;

                return { ApplicationObj };
              }, resolve(true));
            });
          });
      });
    }
  }

  finishSubmitBreak() {
    if (this.state.ApplicationObj.Step1.SubmittingApplication === false) {
      this.isSubmitting(true, "Step1").then(async () => {
        const self = this;

        let applyObj = {
          I20: this.state.ApplicationObj.Step1.I20Number,
          Plan: this.getPlanInitial(),
          Email: this.state.ApplicationObj.Step1.Email,
          PhoneNumber: this.state.ApplicationObj.Step1.PhoneNumber,
          Street: this.state.ApplicationObj.Step1.Street,
          Street2: this.state.ApplicationObj.Step1.Street2,
          City: this.state.ApplicationObj.Step1.City,
          State: this.state.ApplicationObj.Step1.State,
          Zip: this.state.ApplicationObj.Step1.Zip,
          OtherReason: this.state.ApplicationObj.Step1.OtherReason,
          LevelReason: this.state.ApplicationObj.Step1.LevelReason,
          DocumentSignature: {
            FileContentBase64: this.state.ApplicationObj.Step1.trimmedDataURL,
            FileName: "Signature.jpg"
          },
          DocumentInitials: {
            FileContentBase64:
              this.state.ApplicationObj.Step1.trimmedDataURLInitials,
            FileName: "Initials.jpg"
          }
        };

        const isDevelopment = false;
        const url = isDevelopment
          ? "http://localhost:58794"
          : "https://api.lumos.edu";

        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(applyObj)
        };

        return fetch(url + "/selfEnroll", requestOptions)
          .then((response) => response.json())
          .then((data) => {
            return new Promise((resolve, reject) => {
              self.setState((prevState) => {
                let ApplicationObj = Object.assign(
                  {},
                  prevState.ApplicationObj
                );
                let step1 = ApplicationObj.Step1;

                if (data.success === true) {
                  alert("Thank you for submitting your self-registration.");
                  window.location.assign("https://lumos.edu");
                } else if (data.messages) {
                  let message = data.messages.map((error) => error).join("\n");

                  step1.ErrorSubmit = message;
                } else {
                  step1.ErrorSubmit = "An internal server error has occurred.";
                }

                step1.SubmittingApplication = false;

                return { ApplicationObj };
              }, resolve(true));
            });
          })
          .catch(function (error) {
            return new Promise((resolve, reject) => {
              self.setState((prevState) => {
                let ApplicationObj = Object.assign(
                  {},
                  prevState.ApplicationObj
                );
                let step1 = ApplicationObj.Step1;

                let msg = self.ErrorMessage(error);
                step1.ErrorSubmit =
                  "A server connection error occurred in your application. Error message: " +
                  msg;

                step1.SubmittingApplication = false;

                return { ApplicationObj };
              }, resolve(true));
            });
          });
      });
    }
  }

  resetModal = () => {
    return new Promise((resolve, reject) => {
      this.setState(this.getModalState(), resolve(true));
    });
  };

  handleSubmit(event) {
    event.preventDefault();

    this.finishSubmit();
  }

  handleSubmitBreak(event) {
    event.preventDefault();

    this.finishSubmitBreak();
  }

  handleStep3SatisfiedChange = (value) => {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        let Step3 = ApplicationObj.Step3;

        Step3.Satisfied = value;
        // Reset preferences when toggling back to Yes
        if (value === true) {
          Step3.PreferredLevel = null;
          Step3.PreferredPeriod = null;
        }

        return { ApplicationObj };
      }, resolve(true));
    });
  };

  handleStep3LevelChange = (order) => {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        ApplicationObj.Step3.PreferredLevel = order;
        return { ApplicationObj };
      }, resolve(true));
    });
  };

  handleStep3PeriodChange = (period) => {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        ApplicationObj.Step3.PreferredPeriod = period;
        return { ApplicationObj };
      }, resolve(true));
    });
  };

  handleStep3Submit = () => {
    const step3 = this.state.ApplicationObj.Step3;

    // If satisfied == true, no need to call backend — just mark done
    if (step3.Satisfied === true) {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        ApplicationObj.Step3.Submitted = true;
        return { ApplicationObj };
      });
      return;
    }

    // Satisfied === false: POST survey data to backend
    this.setState(
      (prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        ApplicationObj.Step3.Submitting = true;
        ApplicationObj.Step3.ErrorSubmit = "";
        return { ApplicationObj };
      },
      () => {
        const self = this;
        const isDevelopment = false;
        const url = isDevelopment
          ? "http://localhost:58794"
          : "https://api.lumos.edu";

        const surveyObj = {
          I20: self.state.ApplicationObj.Step1.I20Number,
          Satisfied: false,
          PreferredLevel: self.state.ApplicationObj.Step3.PreferredLevel,
          PreferredPeriod: self.state.ApplicationObj.Step3.PreferredPeriod
        };

        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(surveyObj)
        };

        fetch(url + "/selfEnroll/survey", requestOptions)
          .then((response) => response.json())
          .then((data) => {
            self.setState((prevState) => {
              let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
              ApplicationObj.Step3.Submitting = false;
              ApplicationObj.Step3.Submitted = true;
              return { ApplicationObj };
            });
          })
          .catch((error) => {
            self.setState((prevState) => {
              let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
              ApplicationObj.Step3.Submitting = false;
              ApplicationObj.Step3.ErrorSubmit =
                "An error occurred while submitting your survey. Please try again.";
              return { ApplicationObj };
            });
          });
      }
    );
  };

  handleCheckbox = (parent, index, e) => {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        let obj = ApplicationObj[parent];

        obj["Agree" + index] = !obj["Agree" + index];

        return { ApplicationObj };
      }, resolve(true));
    });
  };

  handleContactInfoToggle = (action) => {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        let obj = ApplicationObj.Step1;

        if (action === "confirm") {
          obj.ContactInfoConfirmed = !obj.ContactInfoConfirmed;
          if (obj.ContactInfoConfirmed) {
            obj.ContactInfoEditable = false;
          }
        } else if (action === "edit") {
          obj.ContactInfoEditable = !obj.ContactInfoEditable;
          if (obj.ContactInfoEditable) {
            obj.ContactInfoConfirmed = false;
          }
        }

        return { ApplicationObj };
      }, resolve(true));
    });
  };

  ErrorMessage(error) {
    var message = "";

    if (error.response) {
      if (error.response.data) {
        if (error.response.data.messages) {
          message = error.response.data.messages
            .map((error) => error)
            .join("\n");
        } else {
          message = error.response.data;
        }
      } else {
        message = error.message;
      }
    } else if (error.message) {
      message = error.message;
    }

    return message;
  }

  step2FinanceRender = (id) => {
    let title = "";
    let message = "";

    let tuition = 0;

    let course = null;

    let subject = this.getSubject();

    if (this.state.ApplicationObj.Step1.Courses.length == 1) {
      course = this.state.ApplicationObj.Step1.Courses[0];
    } else {
      course = this.state.ApplicationObj.Step1.Courses.find(
        (x) => x.order == subject.courseOrder
      );
    }

    // A campus with a fixed tuition replaces the level price and the per-semester discounts.
    tuition =
      subject && subject.campusFixedTuitionCost != null
        ? subject.campusFixedTuitionCost
        : course && course.newTuitionCost;

    let USDollar = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    });

    let selfEnrollDiscountDate =
      "Due by " +
      dateFns.format(
        this.state.ApplicationObj.Step1.SelfEnrollDiscountDate,
        "MMMM dd, yyyy"
      );

    let applyDiscountRule = this.state.ApplicationObj.Step1.ApplyDiscountRule;

    switch (id) {
      case 1:
        title = applyDiscountRule ? "One Payment (no discount)" : "One Payment";
        message =
          "\n One Payment of " +
          USDollar.format(tuition + tuition * 0.04) +
          " (Tuition: " +
          USDollar.format(tuition) +
          " + Credit Card Fee: " +
          USDollar.format(tuition * 0.04) +
          ")\n\n* Due on the first day of school (" +
          dateFns.format(
            this.state.ApplicationObj.Step1.SemesterStartDate,
            "MM/dd/yyyy"
          ) +
          ")\n\n* If you choose to make any tuition payments in cash, please go in person to the school and the credit/debit card fee for that payment will be removed.";
        break;
      case 2:
        title = applyDiscountRule
          ? "Three Payments (no discount)"
          : "Three Payments";
        message =
          "\n 1st payment of " +
          USDollar.format(tuition / 2 + (tuition / 2) * 0.04) +
          " (Tuition: " +
          USDollar.format(tuition / 2) +
          " + Credit Card Fee: " +
          USDollar.format((tuition / 2) * 0.04) +
          ")\n\n* Due on the first day of school (" +
          dateFns.format(
            this.state.ApplicationObj.Step1.SemesterStartDate,
            "MM/dd/yyyy"
          ) +
          ") \n\n 2nd Payment of " +
          USDollar.format(tuition / 4 + (tuition / 4) * 0.04) +
          " (Tuition: " +
          USDollar.format(tuition / 4) +
          " + Credit Card Fee: " +
          USDollar.format((tuition / 4) * 0.04) +
          ")\n\n* Due 30 days after the first day of school (" +
          dateFns.format(
            dateFns.addMonths(
              this.state.ApplicationObj.Step1.SemesterStartDate,
              1
            ),
            "MM/dd/yyyy"
          ) +
          ") \n\n 3rd Payment of " +
          USDollar.format(tuition / 4 + (tuition / 4) * 0.04) +
          " (Tuition: " +
          USDollar.format(tuition / 4) +
          " + Credit Card Fee: " +
          USDollar.format((tuition / 4) * 0.04) +
          ")\n\n* Due 60 days after the first day of school (" +
          dateFns.format(
            dateFns.addMonths(
              this.state.ApplicationObj.Step1.SemesterStartDate,
              2
            ),
            "MM/dd/yyyy"
          ) +
          ") \n\n* If you choose to make any tuition payments in cash, please go in person to the school and the credit/debit card fee for that payment will be removed.";
        break;

      case 3:
        title = "One Payment (U$100.00 discount)";
        message =
          "\n One Payment of " +
          USDollar.format(tuition - 100 + (tuition - 100) * 0.04) +
          " (Tuition: " +
          USDollar.format(tuition - 100) +
          " + Credit Card Fee: " +
          USDollar.format((tuition - 100) * 0.04) +
          ")\n\n* " +
          selfEnrollDiscountDate +
          "\n\n* If you choose to make any tuition payments in cash, please go in person to the school and the credit/debit card fee for that payment will be removed.";
        break;

      case 4:
        title = applyDiscountRule
          ? "Two Payments (U$100.00 discount)"
          : "Two Payments";
        message = applyDiscountRule
          ? "\n 1st payment of " +
            USDollar.format(
              (tuition - 100) / 2 + ((tuition - 100) / 2) * 0.04
            ) +
            " (Tuition: " +
            USDollar.format((tuition - 100) / 2) +
            " + Credit Card Fee: " +
            USDollar.format(((tuition - 100) / 2) * 0.04) +
            ")\n\n* " +
            selfEnrollDiscountDate +
            "\n\n 2nd Payment of " +
            USDollar.format(
              (tuition - 100) / 2 + ((tuition - 100) / 2) * 0.04
            ) +
            " (Tuition: " +
            USDollar.format((tuition - 100) / 2) +
            " + Credit Card Fee: " +
            USDollar.format(((tuition - 100) / 2) * 0.04) +
            ")\n\n* Due 30 days after the first day of school (" +
            dateFns.format(
              dateFns.addMonths(
                this.state.ApplicationObj.Step1.SemesterStartDate,
                1
              ),
              "MM/dd/yyyy"
            ) +
            ") \n\n* If you choose to make any tuition payments in cash, please go in person to the school and the credit/debit card fee for that payment will be removed."
          : "\n 1st payment of " +
            USDollar.format(tuition / 2 + (tuition / 2) * 0.04) +
            " (Tuition: " +
            USDollar.format(tuition / 2) +
            " + Credit Card Fee: " +
            USDollar.format((tuition / 2) * 0.04) +
            ")\n\n* Due on the first day of school (" +
            dateFns.format(
              this.state.ApplicationObj.Step1.SemesterStartDate,
              "MM/dd/yyyy"
            ) +
            ") \n\n 2nd Payment of " +
            USDollar.format(tuition / 2 + (tuition / 2) * 0.04) +
            " (Tuition: " +
            USDollar.format(tuition / 2) +
            " + Credit Card Fee: " +
            USDollar.format((tuition / 2) * 0.04) +
            ")\n\n* Due 30 days after the first day of school (" +
            dateFns.format(
              dateFns.addMonths(
                this.state.ApplicationObj.Step1.SemesterStartDate,
                1
              ),
              "MM/dd/yyyy"
            ) +
            ") \n\n* If you choose to make any tuition payments in cash, please go in person to the school and the credit/debit card fee for that payment will be removed.";

        break;

      case 5:
        title = "Three Payments (U$100.00 discount)";
        message =
          "\n 1st payment of " +
          USDollar.format((tuition - 100) / 2 + ((tuition - 100) / 2) * 0.04) +
          " (Tuition: " +
          USDollar.format((tuition - 100) / 2) +
          " + Credit Card Fee: " +
          USDollar.format(((tuition - 100) / 2) * 0.04) +
          ")\n\n* " +
          selfEnrollDiscountDate +
          "\n\n 2nd Payment of " +
          USDollar.format((tuition - 100) / 4 + ((tuition - 100) / 4) * 0.04) +
          " (Tuition: " +
          USDollar.format((tuition - 100) / 4) +
          " + Credit Card Fee: " +
          USDollar.format(((tuition - 100) / 4) * 0.04) +
          ")\n\n* Due 30 days after the first day of school (" +
          dateFns.format(
            dateFns.addMonths(
              this.state.ApplicationObj.Step1.SemesterStartDate,
              1
            ),
            "MM/dd/yyyy"
          ) +
          ") \n\n 3rd Payment of " +
          USDollar.format((tuition - 100) / 4 + ((tuition - 100) / 4) * 0.04) +
          " (Tuition: " +
          USDollar.format((tuition - 100) / 4) +
          " + Credit Card Fee: " +
          USDollar.format(((tuition - 100) / 4) * 0.04) +
          ")\n\n* Due 60 days after the first day of school (" +
          dateFns.format(
            dateFns.addMonths(
              this.state.ApplicationObj.Step1.SemesterStartDate,
              2
            ),
            "MM/dd/yyyy"
          ) +
          ") \n\n* If you choose to make any tuition payments in cash, please go in person to the school and the credit/debit card fee for that payment will be removed.";
        break;
    }

    swal(title, message, "warning").then(() => {
      return new Promise((resolve, reject) => {
        this.setState((prevState) => {
          let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
          let Step2 = ApplicationObj.Step2;

          Step2.FinanceId = id;

          return { ApplicationObj };
        }, resolve(true));
      });
    });
  };

  emailIsValid(email) {
    return (
      email.length > 0 && email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
    );
  }

  emailOnBlur = async (e) => {
    const value = e.target.value;

    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        let Step1 = ApplicationObj.Step1;

        Step1.InvalidEmail = !this.emailIsValid(value);

        return { ApplicationObj };
      }, resolve(true));
    });
  };

  handleSelectStateChange = (event) => {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        let Step1 = ApplicationObj.Step1;

        Step1.State = event.target.value;

        return { ApplicationObj };
      }, resolve(true));
    });
  };

  handlePhoneNumberChange = (e) => {
    return new Promise((resolve, reject) => {
      this.setState((prevState) => {
        let ApplicationObj = Object.assign({}, prevState.ApplicationObj);
        let Step1 = ApplicationObj.Step1;

        const { formatted, isValid } = this.normalizePhoneNumber(
          e.target.value
        );

        Step1.PhoneNumber = formatted;
        Step1.PhoneNumberIsValid = isValid;

        return { ApplicationObj };
      }, resolve(true));
    });
  };

  normalizePhoneNumber = (rawValue) => {
    let onlyNumbers = (rawValue || "").replace(/\D/g, "");

    if (onlyNumbers.length === 11 && onlyNumbers.startsWith("1")) {
      onlyNumbers = onlyNumbers.slice(1);
    }
    onlyNumbers = onlyNumbers.slice(0, 10);

    return {
      formatted: this.formatPhoneNumber(onlyNumbers),
      isValid: onlyNumbers.length === 0 || onlyNumbers.length === 10
    };
  };

  formatPhoneNumber = (phoneNumber) => {
    if (phoneNumber.length <= 3) {
      return phoneNumber;
    } else if (phoneNumber.length <= 6) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    } else {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
        3,
        6
      )}-${phoneNumber.slice(6, 10)}`;
    }
  };
}

export default VersionOne;
